<template>
  <div class="home">
    <ul class="filters">
      <li>
        <a
          v-on:click="showActive"
          v-bind:class="{ selected: filter === 'active' }"
          >Confirmed</a
        >
      </li>
      <li>
        <a
          v-on:click="showBusiness"
          v-bind:class="{ selected: filter === 'business' }"
          >Business</a
        >
      </li>
      <li>
        <a
          v-on:click="showPinned"
          v-bind:class="{ selected: filter === 'pinned' }"
          >Pinned {{ numPinned }}</a
        >
      </li>
      <li>
        <a
          v-on:click="showIssues"
          v-bind:class="{ selected: filter === 'issues' }"
          >Unpaid {{ totalPayment ? totalPayment + ' €' : '' }}</a
        >
      </li>
      <li>
        <a
          v-on:click="showOpen"
          v-bind:class="{ selected: filter === 'open' }"
          >Open</a
        >
      </li>
      <li>
        <a
          v-on:click="showClosed"
          v-bind:class="{ selected: filter === 'closed' }"
          >Closed</a
        >
      </li>
      <li>
        <a
          v-on:click="showDisputes"
          v-bind:class="{ selected: filter === 'disputes' }"
          >Disputes</a
        >
      </li>
      <li>
        <a
          v-on:click="showSearch"
          v-bind:class="{ selected: filter === 'search' }"
          >Search</a
        >
      </li>
    </ul>
    <div class="data-table" id="orders-table">
      <div class="header">
        <div>ID</div>
        <div>Skill</div>
        <div>Worker</div>
        <div>Client</div>
        <div>Payment</div>
        <div>Created At</div>
        <div>Scheduled At</div>
        <div>Status</div>
        <div>Actions</div>
      </div>
      <div v-if="filter === 'search'" class="row">
        <div class="cell id inputcell">
          <input style="width:300px" placeholder="Enter ID" v-model.trim="searchId" autofocus /><br />
          <input style="width:300px" placeholder="Enter CODE" v-model.trim="searchCode" /><br/>
          <input style="width:300px" placeholder="Client Invoice No" v-model.trim="invoiceNumber" />
        </div>
        <div class="cell inputcell"></div>
        <div class="cell inputcell">
          <input placeholder="Enter worker ID" v-model.trim="searchWorkerId"  /><br />
          <input placeholder="Enter owner ID" v-model.trim="searchOwnerId"  />
        </div>
        <div class="cell inputcell"><input placeholder="Enter client ID" v-model.trim="searchClientId"  />
          <br /><input placeholder="Enter company ID" v-model.trim="searchCompanyId"  />
          <br /><input placeholder="Enter contact ID" v-model.trim="searchContactId"  />
          <br /><input placeholder="Enter phone number" v-model.trim="searchPhoneNumber"  />
          <br /><input placeholder="Enter email" v-model.trim="searchEmail"  />
          <br /><input placeholder="Enter first name" v-model.trim="searchFirstName"  />
          <br /><input placeholder="Enter last name" v-model.trim="searchLastName"  />
        </div>
        <div class="cell inputcell"></div>
        <div class="cell inputcell"></div>
        <div class="cell inputcell"></div>
        <div class="cell inputcell"></div>
        <div class="cell actions" style="display: flex">
          <button
            v-on:click="clearSearch"
          >
            Clear
          </button>
          <button
            v-on:click="searchOrders"
          >
            Search
          </button>
        </div>
      </div>
      <div
        v-for="order in orders"
        v-bind:key="order.id"
        class="row"
        v-bind:class="{ finished: order.finished }"
      >
        <div class="cell" style="font-size: 14px;padding:3px 5px 0px 5px;">
          <span v-if="order.code" style="font-weight: bold">{{order.code}}<br/></span>
          order:{{ order.id }}<br /><span style="font-size: 14px;"
            >task:{{ order.taskId }}</span
          ><br />
          <span v-if="order.pinned" style="color:darkgoldenrod;font-weight: bold;font-size: 10px">📌 </span>
          <span v-if="order.legalStatus" style="color:red;font-weight: bold;">dispute </span>
          <span style="color:#B082F9;font-weight: bold">{{order.assignmentStrategy ? order.assignmentStrategy : ''}}{{order.creationGui === 'web' ? 'web' : ''}}</span>
          <div v-if="order.tags && order.tags.length" style="line-height: 28px;">
            <div v-for="tag in (order.tags || [])" :style="getTagStyle(tag)">{{ tag }}</div>
          </div>
        </div>
        <div class="cell">
          {{order.country}}:
          <router-link :to="{ name: 'orderPage', params: { id: order.id } }">{{
            storeReader.getSkillTitle(order.skillId)
          }}</router-link>
        </div>
        <div class="cell">
          {{ getName(order.workerId) }}
          <span style="color:#B082F9;font-size: 12px;font-weight:bold;display:block; margin-top: 3px" v-if="users[order.workerId] && !users[order.workerId].tasksCompleted">FIRST ORDER</span>
        </div>
        <div class="cell">
          <b v-if="order.companyId" >{{ (companies[order.companyId] || {name: ''}).name }}<br/></b>
          {{ getName(order.clientId) }}
          <span style="display:block">{{ order.contactId || '' }}</span>
          <span>{{order.details.address.textValue}}</span>
        </div>
        <div class="cell" v-if="order.worklog">
          <span v-if="order.status==='completed'">{{ getPaymentAmount(order) ? '[UNPAID ' + getPaymentAmount(order) + ']' : '[paid]' }}</span>
          {{ order.worklog && order.worklog.discountedTotal ? order.worklog.discountedTotal / 100 : "" }}
          <!-- {{ (order.worklog.promoCodes || []).length ? order.worklog.promoCodes : "" }} -->
        </div>
        <div v-else>

        </div>
        <div class="cell">
          {{
            order.createdAt
              ? new Date(order.createdAt._seconds * 1000).toLocaleDateString()
              : "-"
          }}
          <br />
          <span v-if="order.seenAt">SEEN {{order.seenAt}}</span>
          <span v-else style="color:#e64420">NOT SEEN</span>
          <div v-if="order.lastCall">Called</div>
          <div v-else style="color:#e64420; font-weight: bold;">Nocall</div>
          <div v-if="order.timeUpdates.length">RESCHEDULEDx{{ order.timeUpdates.length }}</div>
        </div>
        <div class="cell">
          {{ order.scheduledText ? order.scheduledText : "-" }}
          <span
            style="display:block;font-size: 12px"
            v-if="order.timeToAction"
            >{{ order.timeToAction }}</span
          >
        </div>
        <div class="cell" style="padding-bottom: 0">
          <div v-html="order.statusText"></div>
          <table v-if="order.status === 'completed'" style="margin-top: 5px">
            <tr>
              <th style="white-space:nowrap">👩‍💼</th>
              <th style="white-space:nowrap">👷</th>
              <th style="white-space:nowrap">👨‍💼</th>
              <th style="white-space:nowrap">✉️👷</th>
              <th style="white-space:nowrap">✉️👨‍💼</th>
              <th>📒</th>
              <td>🗣️</td>
              <th>💸</th>
            </tr>
            <tr>
              <td v-if="getInvoice(order).dscPdfLink"><a style="text-decoration:none" :href="getInvoiceUrl(getInvoice(order).dscPdfLink, order)">📄</a></td><td v-else>❌</td>
              <td v-if="getInvoice(order).proPdfLink"> <a style="text-decoration:none" :href="getInvoiceUrl(getInvoice(order).proPdfLink, order)">📄</a></td><td v-else>❌</td>
              <td v-if="getInvoice(order).clientPdfLink"> <a style="text-decoration:none" :href="getInvoiceUrl(getInvoice(order).clientPdfLink, order)">📄</a></td><td v-else>❌</td>
              <td v-if="getInvoice(order).proEmailSent">✅</td><td v-else>❌</td>
              <td v-if="getInvoice(order).clientEmailSent">✅</td><td v-else>❌</td>
              <td v-if="getInvoice(order).registeredAt || parseFloat(getInvoice(order).fee) === 0  || getInvoice(order).registrationNo">✅</td><td v-else>❌</td>
              <td v-if="getReview(order)">{{getReview(order).rating}}</td><td v-else>?</td>
              <td v-if="order.transferStatus === 'paid'">✅</td><td v-else-if="order.proPaymentScheduledAt">⌛</td><td v-else>❌</td>
            </tr>
          </table>
        </div>
        <div class="cell actions" style="display: flex">
          <!-- <button v-on:click="transfer(order)" v-if="canTransfer(order)">
            Transfer
          </button> -->
          <div v-if="!order.phoneNumber && order.status === 'confirmed'" style="color:#e64420">NO PHONE NUMBER</div>
          <button v-on:click="charge(order)" v-if="canCharge(order)">
            Charge
          </button>
        </div>
      </div>
    </div>
    <h1 v-if="searching" style="padding: 50px;background-color: white;">Searching...</h1>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<style scoped lang="less">
#orders-table {
  grid-template-columns: auto auto auto auto auto auto auto auto auto;
  .row.finished .cell {
    color: #aaa;
  }
}
.link {
  align-self: center;
}
table {
  border-collapse: collapse;
  width: 100%;
  td, th {
    border: 1px solid gray;
    padding: 2px;
    width: 12.5%;
  }
}
input {
  border: 1px solid #ddd;
  padding: 5px;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import * as storeReader from "../services/storeReader";

export default {
  name: "home",
  data: function() {
    return {
      numPinned: 0,
      storeReader,
      allOrders: [],
      orders: [],
      filter: "",
      users: {},
      tasks: {},
      invoices: {},
      reviews: {},
      companies: {},
      searchWorkerId: '',
      searchOwnerId: '',
      searchClientId: '',
      searchCode: '',
      invoiceNumber: '',
      totalPayment: '',
      searchCompanyId: '',
      searchPhoneNumber: '',
      searchFirstName: '',
      searchLastName: '',
      searchEmail: '',
      searchContactId: '',
      searchId: '',
      searching: false,
      availableTags: []
    };
  },
  async created() {
    this.pros = await api.getPros();
    this.users = this.pros.reduce((prev, next) => {
      prev[next.id] = next;
      return prev;
    }, {});
    this.navigate(this.$route);
    this.availableTags = this.$store.state.config.tags || [];
    // console.log(this.orders.map((order, i) => ({...order, id: i})));
  },
  // watch: {
  //   $route(to) {
  //     this.navigate(to);
  //   }
  // },
  methods: {
    getInvoiceUrl: function(url, order) {
      if (url.indexOf('googleapis') !== -1) {
        const goodUrl = 'https://media.discontract.com/storage/invoices/' + order.invoiceId + url.match('/([^/]*).pdf')[0];
        return goodUrl;
      } else {
        return url;
      }
    },
    getTagStyle(label) {
      for (let i = 0; i < this.availableTags.length; i++) {
        const tag = this.availableTags[i];
        if (tag.label === label) {
          return `display:inline-block;backgroundColor: ${tag.backgroundColor}; color: ${tag.foregroundColor};padding: 3px;border-radius: 3px;margin-right:5px;font-weight: bold`;
        }
      }
    },
    sortOrders: function(u1, u2) {
      // console.log('sorting order');
      const t1 = (u1.createdAt || { _seconds: 0 })._seconds;
      const t2 = (u2.createdAt || { _seconds: 0 })._seconds;
      return t2 - t1;
    },
    mapOrder: function (order) {
      try {
        if (
          (
            !this.canCharge(order) &&
            order.invoiceId &&
            !this.canSendPayment(order) &&
            !order.pinned
          ) || order.closed
        ) {
          order.finished = true;
        }
        return order;
      } catch (e) {
        console.log('error:', e);
        return order;
      }
    },
    getName(clientId) {
      const client = this.users[clientId];
      if (client) {
        return client.firstName + ' ' + client.lastName;
      } else {
        return clientId;
      }
    },
    getInvoice(order) {
      return this.invoices[order.invoiceId] || {};
    },
    getReview(order) {
      if (order.taskId && this.tasks[order.taskId]) {
        return this.reviews[this.tasks[order.taskId].reviewId];
      }
    },
    timeDiff(t1, t2) {
      if (t1 && t2) {
        const mins = Math.round((t1._seconds - t2._seconds) / 60 * 100) / 100;
        if (mins < 1800) {
          return mins + 'min.';
        }
      }
    },
    showSearch(params = {}) {
      document.title = 'Search/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "search", ...params } })
        .catch(() => {});
      this.orders = [];
      this.filter = "search";
      if (params.workerId) {
        this.searchWorkerId = params.workerId;
        this.searchOrders();
      } else if (params.clientId) {
        this.searchClientId = params.clientId;
        this.searchOrders();
      } else if (params.ownerId) {
        this.searchOwnerId = params.ownerId;
        this.searchOrders();
      } else if (params.companyId) {
        this.searchCompanyId = params.companyId;
        this.searchOrders();
      } else if (params.contactId) {
        this.searchContactId = params.contactId;
        this.searchOrders();
      }
    },
    clearSearch() {
      this.searchWorkerId = '';
      this.searchOwnerId = '';
      this.searchClientId = '';
      this.searchCompanyId = '';
      this.searchId = '';
      this.searchCode = '';
      this.invoiceNumber = '';
      this.searchContactId = '';
      this.searchPhoneNumber = '';
      this.searchEmail = '';
      this.searchFirstName = '';
      this.searchLastName = '';
      this.orders=[];
    },
    searchOrders: async function () {
      // console.log('SEARCH', this.searchWorkerId);
      this.searching = true;
      let orders = [];
      if (this.searchId) {
        orders = await api.searchOrders({orderId: this.searchId.trim()});
      } else if (this.searchCode) {
        orders = await api.searchOrders({code: this.searchCode.trim()});
      } else if (this.searchWorkerId) {
        orders = await api.searchOrders({workerId: this.searchWorkerId.trim()});
      } else if (this.searchOwnerId) {
        orders = await api.searchOrders({ownerId: this.searchOwnerId.trim()});
      } else if (this.searchClientId) {
        orders = await api.searchOrders({clientId: this.searchClientId.trim()});
      } else if (this.searchCompanyId) {
        orders = await api.searchOrders({companyId: this.searchCompanyId.trim()});
      } else if (this.searchContactId) {
        orders = await api.searchOrders({contactId: this.searchContactId.trim()});
      } else if (this.searchPhoneNumber) {
        orders = await api.searchOrders({phoneNumber: this.searchPhoneNumber.trim()});
      } else if (this.invoiceNumber) {
        orders = await api.searchOrders({invoiceNumber: this.invoiceNumber.trim()});
      } else if (this.searchEmail) {
        orders = await api.searchOrders({email: this.searchEmail.trim()});
      } else if (this.searchFirstName) {
        orders = await api.searchOrders({firstName: this.searchFirstName.trim()});
      } else if (this.searchLastName) {
        orders = await api.searchOrders({lastName: this.searchLastName.trim()});
      }
      const allOrders = orders
        .map(this.mapOrder)
        .sort(this.sortOrders);
      this.orders = (await this.loadTasksForOrders(allOrders, false));
      this.orders = this.orders.filter(o => o.taskId);
      this.loadUsersForOrders();
      this.searching = false;
    },
    showDrafts: async function() {
      this.$router
        .push({ name: "orders", query: { filter: "drafts" } })
        .catch(() => {});
      const allOrders = (await api.getDrafts())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      this.orders = allOrders;
      // this.loadTasksForOrders(orders);
      this.filter = "drafts";
      this.loadUsersForOrders();
      this.search = "";
    },
    showActive: async function() {
      document.title = 'Confirmed/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "active" } })
        .catch(() => {});

      // console.log('1');
      const allOrders = (await api.getActiveOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders.filter(
        u => !u.finished && !u.companyId
      );
      this.orders = (await this.loadTasksForOrders(orders, true)).filter(o => o.taskStatus === 'confirmed' || o.taskStatus === 'completed');
      await this.loadReviewsForTasks(Object.values(this.tasks));
      await this.loadInvoicesForOrders(orders);
      this.filter = "active";
      this.loadUsersForOrders();
      this.search = "";
    },
    showIssues: async function() {
      document.title = 'Issues/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "issues" } })
        .catch(() => {});

      // console.log('1');
      const allOrders = (await api.getIssuesOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders;
      this.orders = (await this.loadTasksForOrders(orders, true)).filter(o => o.taskStatus === 'confirmed' || o.taskStatus === 'completed');
      let totalPayment = 0;
      this.orders.forEach(o => {
        totalPayment += this.getPaymentAmount(o) || 0;
      });
      console.log(totalPayment);
      this.totalPayment = Math.round(totalPayment);
      await this.loadReviewsForTasks(Object.values(this.tasks));
      await this.loadInvoicesForOrders(orders);
      this.filter = "issues";
      this.loadUsersForOrders();
      this.search = "";
    },
    showPinned: async function() {
      document.title = 'Pinned/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "pinned" } })
        .catch(() => {});

      // console.log('1');
      const allOrders = (await api.getPinnedOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders;
      this.orders = (await this.loadTasksForOrders(orders, true)).filter(o => o.taskStatus === 'confirmed' || o.taskStatus === 'completed');
      await this.loadReviewsForTasks(Object.values(this.tasks));
      await this.loadInvoicesForOrders(orders);
      this.filter = "pinned";
      this.loadUsersForOrders();
      this.search = "";
      this.numPinned = this.orders.length;
    },
    showBusiness: async function() {
      document.title = 'Business/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "business" } })
        .catch(() => {});

      // console.log('1');
      this.companies = (await api.getCompanies()).reduce(
        (v1, v2) => {
          v1[v2.id] = v2;
          return v1;
        },
        {}
      );
      const allOrders = (await api.getActiveOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders.filter(
        u => !u.finished && u.companyId && u.worklog
      );
      this.orders = (await this.loadTasksForOrders(orders, true)).filter(o => o.taskStatus === 'confirmed' || o.taskStatus === 'completed');
      await this.loadReviewsForTasks(Object.values(this.tasks));
      await this.loadInvoicesForOrders(orders);
      this.filter = "business";
      this.loadUsersForOrders();
      this.search = "";
    },
    showOpen: async function() {
      document.title = 'Open/Orders';
      // console.log('SHOW OPEN');
      this.$router
        .push({ name: "orders", query: { filter: "open" } })
        // .catch(() => {});

      // console.log('1');
      const allOrders = (await api.getOpenOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders.filter(
        u => !u.finished
      );
      this.orders = (await this.loadTasksForOrders(orders, false)).filter(o => !(o.taskStatus === 'confirmed' || o.taskStatus === 'completed'));
      await this.loadReviewsForTasks(Object.values(this.tasks));
      await this.loadInvoicesForOrders(orders);
      this.filter = "open";
      this.loadUsersForOrders();
      this.search = "";
    },
    loadReviewsForTasks: async function(tasks) {
      this.reviews = (await api.getReviewsByIds(tasks.filter(o => o.reviewId).map(o => o.reviewId))).reduce((prev, next) => {
        prev[next.id] = next;
        return prev;
      }, {});
    },
    loadInvoicesForOrders: async function(orders) {
      this.invoices = (await api.getInvoicesByIds(orders.filter(o => o.invoiceId).map(o => o.invoiceId))).reduce((prev, next) => {
        prev[next.id] = next;
        return prev;
      }, {});
    },
    loadTasksForOrders: async function(orders, sort = false) {
      if (!orders.length) {
        return [];
      }
      this.tasks = (await api.getTasksByIds(orders.filter(o => o.taskId).map(o => o.taskId))).reduce((prev, next) => {
        prev[next.id] = next;
        return prev;
      }, {});
      const mappedOrders = orders.map(order => {
        const task = order.taskId ? this.tasks[order.taskId] : {status: 'completed', datetime: order.details.datetime};
        order.taskStatus = task.status;
        order.phoneNumber = task.supportNumber;
        order.scheduledAt = task.datetime ? task.datetime.timestamp : null;
        order.seenAt = this.timeDiff(((task.notifications || {})[task.workerId] || {}).firstTimeOpenedAt, task.createdAt);
        order.lastCall = ((order.events || []).find(e => e.type == 'hangup' && e.duration && e.taskId === order.taskId));
        order.timeUpdates = (order.events || []).filter(e => e.type == 'update_time');
        const slots = order.details.datetime.slots || [];
        const proposedAt = slots[0] || {};
        if (order.scheduledAt) {
          const timeToAction = Math.round(
            (order.scheduledAt - +new Date()) / 1000 / 3600
          );
          const timezones = {
            PL: 'Europe/Warsaw',
            LT: 'Europe/Vilnius',
          };
          order.scheduledText = dayjs(order.scheduledAt).tz(timezones[order.country]).format('YYYY-MM-DD HH:mm');
          if (timeToAction >= 0 && timeToAction <= 24) {
            order.timeToAction = "IN " + timeToAction + "h.";
          } else if (
            timeToAction <= 0 &&
            task.status === "confirmed"
          ) {
            order.timeToAction = "IN PROGRESS " + -timeToAction + "h.";
          } else if (
            order.completedAt &&
            this.canSendPayment(order)
          ) {
            const timeAfterCompletion = Math.round(
              (order.completedAt._seconds * 1000 -
                +new Date()) /
                1000 /
                3600
            );
            order.timeToAction =
              "COMPLETED " + (timeAfterCompletion * -1) + "h.";
          } else if (
            order.completedAt
          ) {
            order.timeToAction =
              "COMPLETED " + dayjs(order.completedAt._seconds * 1000).format('YYYY-MM-DD');
          }
        } else {
          order.scheduledText = proposedAt.dateText + " " + proposedAt.timeText + " [" + (slots.length - 1) + "]";
        }
        order.statusText = [
          order.status,
          task.status
        ].join(":");
        if (order.statusText == 'completed:completed' && this.canSendPayment(order)) {
          order.statusText = this.getAutoPaymentStatus(order);
        }
        return order;
      });
      if (sort) {
        return mappedOrders.sort((o1, o2) => {
          return o1.scheduledAt - o2.scheduledAt;
        });
      } else {
        return mappedOrders;
      }
    },
    getPaymentAmount: function(order) {
      if (!order) {
        return false;
      }
      if (!order.paymentStatus) {
        return false;
      }
      if (!order.worklog) {
        return false;
      }
      if (order.worklog.paymentAmount) {
        return order.worklog.paymentAmount / 100;
      } else if (order.paymentStatus && order.paymentStatus !== 'paid') {
        return order.worklog.discountedTotal / 100;
      }
    },
    getAutoPaymentStatus(order) {
      if (order.proPaymentScheduledAt) {
        return '<span style="color:green">AUTOPAYMENT ENABLED<br />' + dayjs(order.proPaymentScheduledAt._seconds * 1000).format('YYYY-MM-DD HH:mm') + '</span>';
      } else {
        return '<span style="color:gray">AUTOPAYMENT DISABLED</span>';
      }
    },
    loadUsersForOrders: async function() {
      const usersToLoad = [];
      this.orders.forEach((order) => {
        if (!this.users[order.clientId]) {
          if (usersToLoad.indexOf(order.clientId) === -1) {
            usersToLoad.push(order.clientId);
          }
        }
        if (!this.users[order.workerId] && order.workerId) {
          if (usersToLoad.indexOf(order.workerId) === -1) {
            usersToLoad.push(order.workerId);
          }
        }
      });
      const users = await api.getUsersByIds(usersToLoad);
      const newUsers = users.reduce((prev, next) => {
        prev[next.id] = next;
        return prev;
      }, {});
      // console.log(newUsers);
      this.users = {...this.users, ...newUsers};
      //this.forceUpdate();
    },
    showClosed: async function() {
      document.title = 'Closed/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "closed" } })
        .catch(() => {});
      const allOrders = (await api.getClosedOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders.filter(
        u => u.finished
      );
      this.orders = await this.loadTasksForOrders(orders);
      await this.loadReviewsForTasks(Object.values(this.tasks));
      await this.loadInvoicesForOrders(orders);
      this.filter = "closed";
      this.loadUsersForOrders();
      this.search = "";
    },
    showCancelled: async function() {
      document.title = 'Cancelled/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "cancelled" } })
        .catch(() => {});
      const allOrders = (await api.getCancelledOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders;
      this.orders = await this.loadTasksForOrders(orders);
      this.filter = "cancelled";
      this.loadUsersForOrders();
      this.search = "";
    },
    showDisputes: async function() {
      document.title = 'Disputes/Orders';
      this.$router
        .push({ name: "orders", query: { filter: "disputes" } })
        .catch(() => {});
      const allOrders = (await api.getDisputedOrders())
        .map(this.mapOrder)
        .sort(this.sortOrders);
      const orders = allOrders;
      this.orders = await this.loadTasksForOrders(orders);
      this.filter = "disputes";
      this.loadUsersForOrders();
      this.search = "";
    },
    transfer: order => {
      if (confirm("Are you sure you want to transfer this order?")) {
        api.transfer(order.id);
        // order.status = 'processing';
      }
    },
    canViewInvoice: order => {
      if (order.status === "completed") {
        return true;
      }
      return false;
    },
    charge: order => {
      if (confirm("Are you sure you want to charge order " + order.id + "?")) {
        api.charge(order.id);
        // order.status = 'processing';
      }
    },
    canTransfer: function(order) {
      // console.log(order);
      if (!order.taskId) {
        return false;
      }
      return false;
    },
    canCharge: function(order) {
      if (order.paymentStatus === "failed" || (order.worklog && order.worklog.paymentAmount)) {
        // console.log(this.tasks);
        return true;
      }
      return false;
    },
    canSendPayment: order => {
      if (order.status === "completed" && order.transferStatus !== "paid") {
        return true;
      }
      return false;
    },
    navigate(route) {
      console.log("NAVIGATE", route.query.filter);
      const filter = route.query.filter;
      if (filter === "search") {
        this.showSearch(route.query);
      } else if (filter === "closed") {
        this.showClosed();
      } else if (filter === "cancelled") {
        this.showCancelled();
      } else if (filter === "disputes") {
        this.showDisputes();
      } else if (filter === "business") {
        this.showBusiness();
      } else if (filter === "open") {
        this.showOpen();
      } else if (filter === "issues") {
        this.showIssues();
      } else if (filter === "pinned") {
        this.showPinned();
      } else {
        this.showActive();
      }
    }
  }
  // components: {
  //   HelloWorld
  // }
};
</script>
